import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/NotFound.css';

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="notfound-container">
      <div className="notfound-content">

        <div className="notfound-number">
          <span>4</span>
          <span className="notfound-zero">0</span>
          <span>4</span>
        </div>

        <h1 className="notfound-title">Page introuvable</h1>
        <p className="notfound-description">
          Oups ! La page que vous recherchez n'existe pas ou a été déplacée.
        </p>

        <div className="notfound-actions">
          <button className="notfound-btn-home" onClick={() => navigate('/')}>
            ← Retour à l'accueil
          </button>
          <button className="notfound-btn-back" onClick={() => navigate(-1)}>
            Page précédente
          </button>
        </div>

      </div>

      {/* Décoration flottante */}
      <div className="notfound-decoration">
        <div className="notfound-circle c1"></div>
        <div className="notfound-circle c2"></div>
        <div className="notfound-circle c3"></div>
      </div>
    </div>
  );
}

export default NotFound;
